import { Alert, Typography } from '@mui/material';
import type { ReportCoverage } from '../dashboard/types';

export interface PartialCoverageNoticeProps {
  /** The report whose coverage is being disclosed; `undefined` while loading. */
  coverage: Pick<ReportCoverage, 'accountsIncluded' | 'accountsTotal'> | undefined;
  /** Translated message, e.g. "Covers 1 of 2 carrier accounts…". The caller owns the copy. */
  message: string;
}

/**
 * Discloses that a month's totals cover only some of the customer's carrier accounts.
 *
 * Billing periods are per-account, so a month can be aggregated before every account's
 * invoice has landed. The figures shown are real, but partial — and a partial roll-up
 * presented as a whole-organization total is exactly the defect BUG-058 (AU-30) removed.
 * Renders nothing when coverage is complete, so the common case stays uncluttered.
 */
export function PartialCoverageNotice({ coverage, message }: PartialCoverageNoticeProps) {
  if (!coverage || coverage.accountsIncluded >= coverage.accountsTotal) {
    return null;
  }

  return (
    <Alert severity="info" variant="outlined" sx={{ alignItems: 'center' }}>
      <Typography component="span" sx={{ fontSize: 13.5 }}>
        {message}
      </Typography>
    </Alert>
  );
}
